import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { dateParser } from '#validation';
export const GuestLinkAclResponseSchema = z.object({
    guestLinkId: z.string(),
    email: z.string(),
    createdByMemberId: z.string(),
    createdAt: dateParser(),
    lastUsedAt: dateParser().nullable(),
});
export class GuestLinkAclResponseDto extends createZodDto(GuestLinkAclResponseSchema) {
}
